import src from "IMAGE";
export default { src, width: 5, height: 3, blurWidth: 0, blurHeight: 0};
